import styled from "styled-components";
import { VCenter } from "../../../shared/src/Components/Stacks.ts";
import Subrina from "../../../shared/src/img/Subrina.tsx";

import { GigaTitle } from "../../../shared/src/Components/Typography.ts";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    background-color: var(--background);
    color: var(--text);
`;

function Homepage() {
    // const EXTENSION_ID = process.env.EXT_ID; //temp id from dev build

    // function checkExtensionInstalled() {
    //     return new Promise((resolve) => {
    //         chrome.runtime.sendMessage(EXTENSION_ID, {type: "isExtensionInstalled"}, (response) => {
    //             if (chrome.runtime.lastError || !response) {
    //                 resolve(false);
    //             } else {
    //                 resolve(true);
    //             }
    //         });
    //     });
    // }

    // checkExtensionInstalled().then((isInstalled) => {
    //     if (isInstalled) {
    //         console.log("go crypto!");
    //     } else {
    //         console.log("extension is not installed");
    //     }
    // });

    return (
        <>
            <Container>
                <VCenter>
                    <GigaTitle>subscrypto</GigaTitle>
                    <Subrina size={190} />
                </VCenter>
            </Container>
        </>
    );
}

export default Homepage;
